export const VARIABLE_TYPE_OPTIONS = [
  { id: 'multiple', label: 'multiple' },
  // { id: 'single', label: 'single' },
]

export const VALUE_TYPE_OPTIONS = [
  { id: 'string', label: 'string' },
  { id: 'object', label: 'object' },
]

export enum RESERVED_VARIABLES_NAMES {
  FORM_OBJECT_ID = 'form_object_id',
  PREFILL_OBJECT_ID = 'prefill_object_id',
  PREFILL_OBJECT_CODE = 'prefill_object_code',
}
